import { Component, OnInit } from '@angular/core';
import { KaufpreisFormWrapperComponent } from '../../components/kaufpreis-form-wrapper/kaufpreis-form-wrapper.component';
import { PageTitleComponent } from '@base/components/page-title/page-title.component';
import { KaufpreisCalculatorComponent } from '../../components/kaufpreis-calculator/kaufpreis-calculator.component';
import { getAdvertiserId } from '@base/app/shared/utils/get-advertiser-id.helper';

@Component({
  selector: 'app-kaufpreis-page',
  standalone: true,
  imports: [
    PageTitleComponent,
    KaufpreisFormWrapperComponent,
    KaufpreisCalculatorComponent
  ],
  templateUrl: './kaufpreis-page.component.html',
  styleUrl: './kaufpreis-page.component.scss'
})
export class KaufpreisPageComponent implements OnInit {

  submitted = false;

  premium = 0;
  initialPrice = 0;

  servoAdvertiserId: string | null = null;

  showRechner = false;
  noPermission = false;
  isPublic = false;

  ngOnInit() {
    const url = new URL(window.location.href);

    if (url.href.includes('public')) {
      this.handleCustomerViaReferrer(url);
    } else if (url.href.includes('stella')) {
      this.handleCustomerViaApp(url);
    } else {
      this.handleCustomerViaMakler(url);
    }
  }

  private handleCustomerViaReferrer(url: URL): void {
    if (!this.hasUrlAdvertiserId(url)) {
      this.noPermission = true;
      return;
    }

    this.servoAdvertiserId = getAdvertiserId(url);
    this.showRechner = true;
      this.isPublic = true;
  }

  private handleCustomerViaApp(url: URL): void {
    if (!url.searchParams.has('advertiserId')) {
      this.noPermission = true;
      return;
    }

    this.servoAdvertiserId = getAdvertiserId(url);
    this.showRechner = true;
    this.isPublic = false;
  }

  private handleCustomerViaMakler(url: URL): void {
    this.showRechner = false;

    if (!this.hasUrlAdvertiserId(url) || !url.searchParams.has('premium') || !url.searchParams.has('price')) {
      this.noPermission = true;
      return;
    }

    this.servoAdvertiserId = getAdvertiserId(url);

    this.initialPrice = Number(url.searchParams.get('price'));
    this.premium = Number(url.searchParams.get('premium'));
    this.noPermission = false;
    this.isPublic = false;
  }

  onRequestOffer(event: { initialPrice: number, premium: number }): void {
    this.premium = event.premium;
    this.initialPrice = event.initialPrice;
    this.showRechner = false;
  }

  // there are still some qr-codes which have an old maklerId / referrerId instead of the new advertiserId
  hasUrlAdvertiserId(url: URL): boolean {
    return url.searchParams.has('maklerId') || url.searchParams.has('advertiserId') || url.searchParams.has('referrerId');
  }
}
